/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".date-input-form{padding:0;width:100%;height:auto}.time-input{margin-top:0}.time-input .mat-form-field-wrapper{margin-right:8px}.time-input .mat-input-container{width:100%}.time-input .mat-form-field-wrapper[timeselect]{padding-bottom:22px}.time-input .mat-input-infix{border-top:7px solid transparent}.time-input *{min-width:auto!important}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/datetime.input/datetime.input.component.scss.ngstyle.js.pre-build-optimizer.js